/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { challengeClipSchema } from '../challenge-clip-schema';

export const listAllClipsResponseDataSchema = z.array(challengeClipSchema);

export type IListAllClipsResponseData = z.infer<typeof listAllClipsResponseDataSchema>;

export const listAllClipsResponseSchema = createApiResponseSchema(
  listAllClipsResponseDataSchema,
) as z.ZodSchema<IAPI<IListAllClipsResponseData>>;

export type IListAllClipsResponse = IAPI<IListAllClipsResponseData>;
